<div fxLayout="column">
    <ppw-toolbar [menuTitle]="pageTitle" [showMenu]="true" [singleButton]="true" class="sticky-header">
        <div class="ppw-speed-dial-position">
            <button
                mat-mini-fab
                class="speed-dial-button"
                (click)="archive()"
                *ngIf="selectedEmployee"
                matTooltip="Archive employee">
                <mat-icon>remove_circle</mat-icon>
            </button>
            <button
                mat-mini-fab
                class="speed-dial-button"
                (click)="edit()"
                *ngIf="selectedEmployee"
                matTooltip="Edit employee">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-mini-fab class="speed-dial-button" (click)="create()" matTooltip="Create employee">
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
    </ppw-toolbar>
    <table mat-table [dataSource]="employees$" class="mat-elevation-z8 ppw-list" fxFill>
        <ng-container matColumnDef="userName">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>User name</th>
            <td mat-cell *matCellDef="let element">{{ element.userName }}</td>
        </ng-container>
        <ng-container matColumnDef="firstName">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>First name</th>
            <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
        </ng-container>
        <ng-container matColumnDef="lastName">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>Last name</th>
            <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="atlassianId">
            <th class="mat-table-sticky-64" mat-header-cell *matHeaderCellDef>Atlassian Account Id</th>
            <td
                mat-cell
                *matCellDef="let element"
                class="link-to-atlassian"
                (click)="goToAtlassianPeople(element.atlassianAccountId)">
                {{ element.atlassianAccountId }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            [class.ppw-list-highlight]="selectedEmployee === element"
            *matRowDef="let element; columns: displayedColumns"
            (click)="select(element)"></tr>
    </table>
</div>
